import { render, staticRenderFns } from "./SyncList.vue?vue&type=template&id=2c48a949&scoped=true"
import script from "./SyncList.vue?vue&type=script&lang=ts"
export * from "./SyncList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c48a949",
  null
  
)

export default component.exports